module.exports = __webpack_public_path__ + "static/media/46.2e3af455.png";